// These are the assemblies for which there is a sequence file located at
// http://hgdownload.soe.ucsc.edu/goldenPath/${assemblyName}/bigZips/${assemblyName}.2bit
// This list was generated by `getUcscAssemblies.js`

export default `ailMel1
allMis1
anoCar1
anoCar2
anoGam1
anoGam3
apiMel1
apiMel2
aplCal1
aptMan1
aquChr2
balAcu1
bisBis1
bosTau2
bosTau3
bosTau4
bosTau6
bosTau7
bosTau8
braFlo1
caeJap1
caePb1
caePb2
caeRem2
caeRem3
calJac1
calJac3
calMil1
canFam1
canFam3
cavPor3
cb3
ce10
ce11
ce2
ce4
ce6
cerSim1
chlSab2
choHof1
chrPic1
ci1
ci2
ci3
criGri1
criGriChoV1
danRer10
danRer11
danRer3
danRer4
danRer5
danRer6
danRer7
dasNov3
dipOrd1
dm1
dm2
dm3
dm6
dp2
dp3
droAna1
droAna2
droEre1
droGri1
droMoj1
droMoj2
droPer1
droSec1
droSim1
droVir1
droVir2
droYak1
droYak2
eboVir3
echTel1
echTel2
equCab1
equCab2
eriEur1
eriEur2
felCat3
felCat4
felCat5
felCat8
fr1
fr2
fr3
gadMor1
galGal2
galGal3
galGal4
galGal5
galGal6
galVar1
gasAcu1
geoFor1
gorGor3
gorGor4
gorGor5
hetGla1
hetGla2
hg16
hg18
hg19
hg38
latCha1
loxAfr3
macEug2
macFas5
manPen1
melGal1
melGal5
melUnd1
micMur1
micMur2
mm10
mm7
mm8
mm9
monDom2
monDom4
monDom5
musFur1
myoLuc2
nanPar1
nasLar1
nomLeu1
nomLeu2
nomLeu3
ochPri2
ochPri3
oreNil2
ornAna1
ornAna2
oryCun2
oryLat2
otoGar3
oviAri1
oviAri3
oviAri4
panPan1
panPan2
panTro1
panTro2
panTro3
panTro4
panTro5
panTro6
papAnu2
papHam1
petMar1
petMar2
ponAbe2
ponAbe3
priPac1
proCap1
pteVam1
rheMac2
rheMac3
rheMac8
rhiRox1
rn4
rn5
rn6
sacCer1
sacCer2
sacCer3
saiBol1
sarHar1
sorAra1
sorAra2
speTri2
strPur1
strPur2
susScr11
susScr2
susScr3
taeGut1
taeGut2
tarSyr1
tarSyr2
tetNig1
tetNig2
thaSir1
triMan1
tupBel1
turTru2
venter1
vicPac1
vicPac2
xenLae2
xenTro1
xenTro2
xenTro3
xenTro7
xenTro9`.split(/\r?\n/)
